export default __webpack_public_path__ + "static/media/Chrome.739cbb07.svg";